export class FieldMergeConstants {
    static readonly DATA_CONTENT_OPTIONS = 'data-content-options';
    static readonly ID = 'id';

    static readonly TFS_FIELD_MERGE = 'tfs-field-merge';
    static readonly FILE_HEADER_FIELD_MERGE = 'file-header-field-merge';
    static readonly DYNAMIC_CONTENT_FIELD_MERGE = 'dynamic-content-field-merge';
    static readonly IMAGE_ASSET = 'image-asset';

    static readonly SPAN = 'span';
    static readonly DIV = 'div';
    static readonly IMG = 'img';

    static readonly SRC = 'src';
    //the following are all froala related classes that are usually automatically generated by froala when interacting with an image
    static readonly FR_ELEMENT = 'fr-element';
    static readonly FR_FIC = 'fr-fic';
    static readonly FR_PASTED_IMAGE = 'data-fr-image-pasted';
    static readonly FR_IMAGE_ERROR = 'fr-image-error';
    static readonly FR_DIB = 'fr-dib';
    //the following are all froala related attributes that are usually automatically generated by froala when interacting with an image
    static readonly FR_DATA_HAS_IMAGE_ERROR = 'data-has-image-error';

    static readonly FR_COPY_KEYS = ['fr-copied-html', 'fr-copied-text'] as const;

    static readonly IMAGE_ASSET_WITH_DATA_OPTIONS_SELECTOR =
        `img[${FieldMergeConstants.DATA_CONTENT_OPTIONS}]` as const;

    static readonly DATA_FILE_NAME = 'data-file-name';
    static readonly DATA_PLAY_ID = 'data-play-id';
    static readonly COPY_SRC = 'data-copy-src';
    static readonly IMAGE_TOKEN_PREFIX = '{{Image.';
    static readonly TOKEN_SUFFIX = '}}';
}
